import React, { PureComponent } from 'react';

import { appConfig } from 'config/customization';
import { UTILITIES } from 'constants/utilitiesMappers';
import { ROUTES } from 'constants/routes';
import { gaTrackPageView } from 'services/AnalyticsService';

import EdenContent from './components/EdenHome';
import EdetContent from './components/EdetHome';
import OthersContent from './components/EjesaHome';

const Components = {
  [UTILITIES.eden]: EdenContent,
  [UTILITIES.edelap]: OthersContent,
  [UTILITIES.edes]: OthersContent,
  [UTILITIES.ejesa]: OthersContent,
  [UTILITIES.edet]: EdetContent,
  [UTILITIES.utilityco]: OthersContent
};

const Component = Components[appConfig.mappers];

class HomeWrapper extends PureComponent {
  componentDidMount() {
    gaTrackPageView(ROUTES.PUBLIC_HOME);
  }

  render() {
    return <Component {...this.props} />;
  }
}

export default HomeWrapper;
